import { render, staticRenderFns } from "./infoNew.vue?vue&type=template&id=2fdb8283&scoped=true"
import script from "./infoNew.vue?vue&type=script&lang=js"
export * from "./infoNew.vue?vue&type=script&lang=js"
import style0 from "./infoNew.vue?vue&type=style&index=0&id=2fdb8283&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdb8283",
  null
  
)

export default component.exports